// src/contexts/PageLoaderContext.jsx
import React, { createContext, useState, useCallback, useContext, useMemo } from 'react';

const PageLoaderContext = createContext(null);

export const PageLoaderProvider = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('');

    const showPageLoader = useCallback((msg = '') => {
        document.body.style.overflow = 'hidden';
        setMessage(msg);
        setIsLoading(true);
    }, []);

    const hidePageLoader = useCallback(() => {
        document.body.style.overflow = '';
        setIsLoading(false);
        setMessage('');
    }, []);

    const contextValue = useMemo(() => ({
        isLoading,
        message,
        showPageLoader,
        hidePageLoader,
    }), [isLoading, message, showPageLoader, hidePageLoader]);

    return (
        <PageLoaderContext.Provider value={contextValue}>
            {children}
        </PageLoaderContext.Provider>
    );
};

export const usePageLoader = () => {
    const context = useContext(PageLoaderContext);
    if (!context) {
        throw new Error('usePageLoader must be used within a PageLoaderProvider');
    }
    return context;
};
